/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_syl_nav_haiku = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haiku Checker`)
};

const es_syl_nav_haiku = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verificador de haiku`)
};

const de_syl_nav_haiku = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haiku-Prüfer`)
};

const nl_syl_nav_haiku = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haiku-controle`)
};

const fr_syl_nav_haiku = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vérificateur de haïku`)
};

const it_syl_nav_haiku = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifica Haiku`)
};

const pt_br2_syl_nav_haiku = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verificador de Haiku`)
};

const pt_syl_nav_haiku = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verificador de Haiku`)
};

const ja_syl_nav_haiku = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`俳句チェッカー`)
};

const zh_syl_nav_haiku = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`俳句检测器`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const syl_nav_haiku = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.syl_nav_haiku(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("syl_nav_haiku", locale)
	if (locale === "en") return en_syl_nav_haiku(inputs)
	if (locale === "es") return es_syl_nav_haiku(inputs)
	if (locale === "de") return de_syl_nav_haiku(inputs)
	if (locale === "nl") return nl_syl_nav_haiku(inputs)
	if (locale === "fr") return fr_syl_nav_haiku(inputs)
	if (locale === "it") return it_syl_nav_haiku(inputs)
	if (locale === "pt-BR") return pt_br2_syl_nav_haiku(inputs)
	if (locale === "pt") return pt_syl_nav_haiku(inputs)
	if (locale === "ja") return ja_syl_nav_haiku(inputs)
	return zh_syl_nav_haiku(inputs)
};